import Position from "./Position";

export default class Word {
    word:string;
    startPosition:Position;
    dirX:number;
    dirY:number;

    constructor(word: string, position:Position, dirX:number, dirY:number) {
        this.word = word;
        this.startPosition = position;
        this.dirX = dirX;
        this.dirY = dirY;
      }

    GetEndPosition():Position {
      return new Position(
        this.startPosition.x + (this.word.length -1 ) * this.dirX,
        this.startPosition.y + (this.word.length -1 ) * this.dirY);
    }
}